import { Button } from '@/components/button';
import { externalLink as ExternalLinkIcon } from '@/components/icons/externalLink';
import { SUPPORT_TICKET_LABEL, SUPPORT_TICKET_URL } from '@/constants/support';

// Provider-independent so early loading failures and error boundaries can always render it.
export default function SupportTicketLink({ className }: { className?: string }) {
  return (
    <Button href={SUPPORT_TICKET_URL} variant="secondary" size="small" className={className} trailingIcon={<ExternalLinkIcon />}>
      {SUPPORT_TICKET_LABEL}
    </Button>
  );
}
